<template>
  <div class="parent">
    <b-row>
      <b-col sm="12" md="12" lg="10">
        <!-- <vs-breadcrumb class="bc mb-5">
          <vs-icon
            icon="content_paste"
            size="small"
            class="vsicon mr-2"
          ></vs-icon>
          <li>
            <a> Report Center </a>
            <span class="vs-breadcrum--separator"> > </span>
          </li>
          <li aria-current="page" class="active">Journey Report</li>
        </vs-breadcrumb> -->

        <!-- Date Input Component -->
        <div class="date-input">
          <b-card class="date-input-card mb-5">
            <b-form>
              <b-row class="d-flex justify-content-center align-items-center">
                <b-col sm="12" md="6" lg="3">
                  <b-form-group label="Device" label-for="v-unit">
                    <v-select
                      v-model="filter.device"
                      :options="deviceList"
                      @search="searchDevice"
                      class="device"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="6" lg="3">
                  <b-form-group label="Filter" label-for="v-unit">
                    <v-select
                      v-model="filter.dateOption"
                      :options="dateList"
                      @search="searchDevice"
                      class="device"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="6" lg="3">
                  <b-form-group label="Start Time" label-for="v-tgl-mulai">
                    <flat-pickr
                      class="date-picker form-control"
                      :disabled="disableDate"
                      :config="{
                        enableTime: true,
                        dateFormat: 'Y-m-d H:i',
                        maxDate: maxDate,
                        time_24hr: true,
                        defaultHour: 0
                      }"
                      v-model="filter.start_time"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="6" lg="3">
                  <b-form-group label="End Time" label-for="v-tgl-selesai">
                    <flat-pickr
                      class="date-picker form-control"
                      :disabled="disableDate"
                      :config="{
                        enableTime: true,
                        dateFormat: 'Y-m-d H:i',
                        maxDate: maxDate,
                        time_24hr: true,
                        defaultHour: 23,
                        defaultMinute: 59
                      }"
                      v-model="filter.end_time"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12" md="6" lg="3">
                  <b-form-group label="Fuel (Km/L)" label-for="v-fuel">
                    <b-form-input
                      id="v-fuel"
                      value="-"
                      class="fuel"
                      placeholder="Input Fuel"
                      v-model="filter.fuel"
                    />
                  </b-form-group>
                </b-col>
                <b-col class="align-self-center" sm="12" md="6" lg="3">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    id="btn-cari"
                    @click="search"
                    block
                    :disabled="loading"
                    class="pl-5 mt-1 vs-con-loading__container"
                  >
                    Search
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </div>

        <!-- List Summary Component -->
        <div class="list-journey">
          <b-card class="list-journey-card">
            <div class="list-journey-head d-flex justify-content-between">
              <h4 class="d-flex align-items-center">List Summary</h4>
              <div class="d-flex entries-export">
                <span class="d-flex align-items-center mr-2">Show Entries</span>
                <vs-dropdown vs-trigger-click class="cursor-pointer mr-5">
                  <div
                    class="p-2 border-2 border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                  >
                    <span class="mr-2">
                      {{
                        row_total - page * per_page > 0
                          ? page * per_page
                          : row_total
                      }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="updatePerPage(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="updatePerPage(25)">
                      <span>25</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="updatePerPage(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="updatePerPage(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  id="btn-export"
                  class="d-flex align-items-center px-5 vs-con-loading__container"
                  :disabled="data < 1"
                  @click="handleDownload"
                >
                  <span>Export Excel</span>
                </b-button>
              </div>
            </div>

            <!-- For Mobile -->
            <div class="d-flex entries-export-mobile d-md-none d-lg-none mt-3">
              <span class="d-flex align-items-center mr-2">Show Entries</span>
              <vs-dropdown vs-trigger-click class="cursor-pointer mr-5">
                <div
                  class="p-2 border-2 border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2">
                    {{
                      row_total - page * per_page > 0
                        ? page * per_page
                        : row_total
                    }}
                  </span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="updatePerPage(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPage(25)">
                    <span>25</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPage(50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPage(100)">
                    <span>100</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                id="btn-export"
                class="d-flex align-items-center px-5 vs-con-loading__container"
                :disabled="data < 1"
                @click="handleDownload"
              >
                <span>Export Excel</span>
              </b-button>
            </div>

            <div class="table-container">
              <table
                class="table table-bordered table-hover"
                style="min-width: 1045px"
              >
                <thead>
                  <tr>
                    <th scope="col" class="lj-head status">STATUS</th>
                    <th scope="col" class="lj-head lokasi">
                      DATE AND LOCATION
                    </th>
                    <th scope="col" class="lj-head durasi">DURATION</th>
                    <th scope="col" class="lj-head map">MAP</th>
                    <th scope="col" class="lj-head jarak">MILEAGE</th>
                    <th scope="col" class="lj-head speed">AVERAGE SPEED</th>
                  </tr>
                </thead>
                <tbody class="table-body text-center">
                  <tr
                    v-for="(item, index) in data"
                    :key="index"
                    class="tr-body"
                  >
                    <td style="width: 100px">
                      <el-tag
                        class="tag"
                        :type="
                          item.vehicle_status === 'Moving' ? 'primary' : 'info'
                        "
                      >
                        {{ item.vehicle_status }}
                      </el-tag>
                    </td>
                    <td style="width: 340px">
                      <div class="timeline text-left">
                        <div class="timeline-wrapper">
                          <ul class="timeline-sessions">
                            <li
                              :class="
                                item.vehicle_status === 'Moving'
                                  ? 'session-1'
                                  : 'session-3'
                              "
                            >
                              <template v-if="item.vehicle_status === 'Moving'">
                                <div class="session-title text-muted">
                                  Start Location
                                </div>
                                <span class="session-subtitle d-block">
                                  {{ item.start_address }}
                                </span>
                                <span
                                  class="session-time text-muted mt-1 d-block"
                                  >{{ item.start }}
                                </span>
                              </template>
                              <template
                                v-if="item.vehicle_status === 'Parking'"
                              >
                                <div class="session-title text-muted">
                                  Parking Location
                                </div>
                                <span class="session-subtitle d-block">
                                  {{ item.address }}
                                </span>
                                <span
                                  class="session-time text-muted mt-1 d-block"
                                >
                                  {{ item.start }}
                                </span>
                              </template>
                              <template v-if="item.vehicle_status === 'Stop'">
                                <div class="session-title text-muted">
                                  Stop Location
                                </div>
                                <span class="session-subtitle d-block">
                                  {{ item.address }}
                                </span>
                                <span
                                  class="session-time text-muted mt-1 d-block"
                                >
                                  {{ item.start }}
                                </span>
                              </template>
                            </li>
                            <li
                              class="session-2"
                              v-if="item.vehicle_status === 'Moving'"
                            >
                              <template>
                                <div class="session-title text-muted">
                                  Finish Location
                                </div>
                                <span class="session-subtitle d-block">
                                  {{ item.end_address }}
                                </span>
                                <span
                                  class="session-time text-muted mt-1 d-block"
                                  >{{ item.end }}
                                </span>
                              </template>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </td>
                    <td style="width: 120px">
                      <img
                        src="@/assets/images/tabler-icon/clock.svg"
                        class="mb-2"
                      />
                      <span class="d-block">
                        {{ item.duration_time }}
                      </span>
                    </td>
                    <td style="width: 120px">
                      <div class="map-wrapper">
                        <a @click="toMapJourney(item)">
                          <img
                            src="@/assets/images/tabler-icon/edited/map-pins-white.svg"
                            class="mb-2"
                          />
                          <span class="d-block">Lihat Map</span>
                        </a>
                      </div>
                    </td>
                    <td style="width: 120px">
                      <template v-if="item.vehicle_status === 'Moving'">
                        <img
                          src="@/assets/images/tabler-icon/route.svg"
                          class="mb-2"
                        />
                        <span class="d-block">{{ item.drive_mileage }} Km</span>
                      </template>
                      <template v-else>
                        <span class="d-block"> - </span>
                      </template>
                    </td>
                    <td style="width: 120px">
                      <template v-if="item.vehicle_status === 'Moving'">
                        <img
                          src="@/assets/images/tabler-icon/Speedometer.svg"
                          class="mb-2"
                        />
                        <span class="d-block">
                          {{ item.average_speed }} Km/Hour
                        </span>
                      </template>
                      <template v-else>
                        <span class="d-block"> - </span>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div
                slot="append"
                v-if="data.length === 0 || loading"
                class="table_empty"
              >
                <b-skeleton-wrapper :loading="loading" class="mb-5">
                  <template #loading>
                    <div class="mb-5">
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="85%"
                      ></b-skeleton>
                      <b-skeleton animation="fade" width="55%"></b-skeleton>
                      <b-skeleton animation="fade" width="70%"></b-skeleton>
                    </div>
                    <div class="mb-5">
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="85%"
                      ></b-skeleton>
                      <b-skeleton animation="fade" width="55%"></b-skeleton>
                      <b-skeleton animation="fade" width="70%"></b-skeleton>
                    </div>
                    <div class="mb-5">
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="85%"
                      ></b-skeleton>
                      <b-skeleton animation="fade" width="55%"></b-skeleton>
                      <b-skeleton animation="fade" width="70%"></b-skeleton>
                    </div>
                    <div class="mb-5">
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="85%"
                      ></b-skeleton>
                      <b-skeleton animation="fade" width="55%"></b-skeleton>
                      <b-skeleton animation="fade" width="70%"></b-skeleton>
                    </div>
                    <div class="mb-5">
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="85%"
                      ></b-skeleton>
                      <b-skeleton animation="fade" width="55%"></b-skeleton>
                      <b-skeleton animation="fade" width="70%"></b-skeleton>
                    </div>
                  </template>
                </b-skeleton-wrapper>
                {{ loading ? '' : 'No Data Available' }}
              </div>
            </div>

            <vs-pagination
              :total="n_page"
              v-model="page"
              class="mt-5"
            ></vs-pagination>
          </b-card>
        </div>
      </b-col>

      <!-- Statistik Component -->
      <b-col sm="12" md="12" lg="2">
        <div class="statistik">
          <b-row>
            <b-col cols="6" md="4" lg="12" class="mb-5">
              <b-card class="statistik-card d-flex align-items-center">
                <b-skeleton-wrapper :loading="loading">
                  <template #loading>
                    <div>
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="auto"
                      ></b-skeleton>
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="60%"
                      ></b-skeleton>
                      <b-skeleton animation="fade" width="75%"></b-skeleton>
                    </div>
                  </template>
                  <div class="statistik-chart text-center p-2">
                    <img
                      src="@/assets/images/file-icons/chart.png"
                      width="100%"
                    />
                    <!-- <vue-apex-charts
                      :type="chartOptions.chart.type"
                      height="auto"
                      width="100%"
                      :options="chartOptions"
                      :series="series"
                      id="chart"
                    ></vue-apex-charts> -->
                  </div>
                  <div class="statistik-title">
                    <span>Total Mileage</span>
                  </div>
                  <div class="statistik-value">
                    <span>
                      {{ total_mileage === '' ? '-' : total_mileage }}
                      Km
                    </span>
                  </div>
                </b-skeleton-wrapper>
              </b-card>
            </b-col>

            <b-col cols="6" md="4" lg="12" class="mb-5">
              <b-card class="statistik-card d-flex align-items-center">
                <b-skeleton-wrapper :loading="loading">
                  <template #loading>
                    <div>
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="auto"
                      ></b-skeleton>
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="60%"
                      ></b-skeleton>
                      <b-skeleton animation="fade" width="75%"></b-skeleton>
                    </div>
                  </template>

                  <div class="statistik-chart text-center p-2">
                    <img
                      src="@/assets/images/file-icons/chart-2.png"
                      width="100%"
                    />
                    <!-- <vue-apex-charts
                      type="bar"
                      height="auto"
                      width="100%"
                      :options="chartOptions"
                      :series="seriesMovingTime"
                      id="chart"
                    ></vue-apex-charts> -->
                  </div>
                  <div class="statistik-title">
                    <span>Total Moving Time</span>
                  </div>
                  <div class="statistik-value">
                    <span>
                      {{ total_moving_time === '' ? '-' : total_moving_time }}
                    </span>
                  </div>
                </b-skeleton-wrapper>
              </b-card>
            </b-col>

            <b-col cols="6" md="4" lg="12" class="mb-5">
              <b-card class="statistik-card">
                <b-skeleton-wrapper :loading="loading">
                  <template #loading>
                    <div>
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="auto"
                      ></b-skeleton>
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="60%"
                      ></b-skeleton>
                      <b-skeleton animation="fade" width="75%"></b-skeleton>
                    </div>
                  </template>

                  <div class="statistik-chart text-center py-5">
                    <img
                      src="@/assets/images/file-icons/progress-bar.png"
                      width="100%"
                    />
                    <!-- <b-progress
                      value="100"
                      max="100"
                      variant="primary"
                      style="border-radius: 40px"
                      striped
                    /> -->
                  </div>
                  <div class="statistik-title">
                    <span>Total Parking Time</span>
                  </div>
                  <div class="statistik-value">
                    <span>
                      {{ total_parking_time === '' ? '-' : total_parking_time }}
                    </span>
                  </div>
                </b-skeleton-wrapper>
              </b-card>
            </b-col>

            <b-col cols="6" md="4" lg="12" class="mb-5">
              <b-card class="statistik-card">
                <b-skeleton-wrapper :loading="loading">
                  <template #loading>
                    <div>
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="auto"
                      ></b-skeleton>
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="60%"
                      ></b-skeleton>
                      <b-skeleton animation="fade" width="75%"></b-skeleton>
                    </div>
                  </template>
                  <div class="statistik-chart text-center py-5">
                    <img
                      src="@/assets/images/file-icons/progress-bar-2.png"
                      width="100%"
                    />
                    <!-- <b-progress
                      value="100"
                      max="100"
                      variant="danger"
                      style="border-radius: 40px"
                      striped
                    /> -->
                  </div>
                  <div class="statistik-title">
                    <span>Total Stop Time</span>
                  </div>
                  <div class="statistik-value">
                    <span>
                      {{ total_stop_time === '' ? '-' : total_stop_time }}
                    </span>
                  </div>
                </b-skeleton-wrapper>
              </b-card>
            </b-col>

            <b-col cols="6" md="4" lg="12" class="mb-5">
              <b-card class="statistik-card d-flex align-items-center">
                <b-skeleton-wrapper :loading="loading">
                  <template #loading>
                    <div>
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="auto"
                      ></b-skeleton>
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="60%"
                      ></b-skeleton>
                      <b-skeleton animation="fade" width="75%"></b-skeleton>
                    </div>
                  </template>

                  <div class="statistik-chart text-center p-2">
                    <img
                      src="@/assets/images/file-icons/chart-3.png"
                      width="100%"
                    />
                    <!-- <vue-apex-charts
                      type="line"
                      height="auto"
                      width="100%"
                      :options="chartOptionsSpeedMax"
                      :series="seriesSpeedMax"
                      id="chart"
                    ></vue-apex-charts> -->
                  </div>
                  <div class="statistik-title">
                    <span>Total Speed Max</span>
                  </div>
                  <div class="statistik-value my-3">
                    <span>
                      {{ total_speed_max === '' ? '-' : total_speed_max }}
                      Km/Hour
                    </span>
                  </div>
                </b-skeleton-wrapper>
              </b-card>
            </b-col>

            <!-- <b-col cols="6" md="4" lg="12" class="mb-5">
              <b-card class="statistik-card d-flex align-items-center">
                <b-skeleton-wrapper :loading="loading">
                  <template #loading>
                    <div>
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="auto"
                      ></b-skeleton>
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="60%"
                      ></b-skeleton>
                      <b-skeleton animation="fade" width="75%"></b-skeleton>
                    </div>
                  </template>
                  <div class="gas-head d-flex justify-content-between gap-5">
                    <div
                      class="gas-wrapper d-flex justify-content-center align-items-center p-3"
                    >
                      <img
                        src="@/assets/images/tabler-icon/edited/gas-station-orange.svg"
                      />
                    </div>
                    <div class="statistik-title d-flex align-items-center">
                      <span>Fuel Consumption</span>
                    </div>
                  </div>

                  <div class="statistik-value my-3">
                    <span>
                      {{ total_used_fuel === '' ? '-' : total_used_fuel }}
                      Liter
                    </span>
                  </div>

                  <div class="statistik-subtitle">
                    <span>Enter your fuel usage in the input field</span>
                  </div>
                </b-skeleton-wrapper>
              </b-card>
            </b-col> -->

            <b-col cols="6" md="4" lg="12" class="mb-5">
              <b-card class="statistik-card d-flex align-items-center">
                <b-skeleton-wrapper :loading="loading">
                  <template #loading>
                    <div>
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="auto"
                      ></b-skeleton>
                      <b-skeleton
                        animation="fade"
                        class="mb-5"
                        width="60%"
                      ></b-skeleton>
                      <b-skeleton animation="fade" width="75%"></b-skeleton>
                    </div>
                  </template>

                  <div class="statistik-chart d-flex justify-content-between">
                    <div
                      class="gas-wrapper d-flex justify-content-center align-items-center p-3"
                    >
                      <img
                        src="@/assets/images/tabler-icon/edited/gas-station-orange.svg"
                      />
                    </div>
                    <div class="statistik-title d-flex align-items-center">
                      <span>Fuel Consumption</span>
                    </div>
                  </div>
                  <div class="statistik-value my-3">
                    <span>
                      {{ total_used_fuel === '' ? '-' : total_used_fuel }}
                      Liter
                    </span>
                  </div>
                  <div class="statistik-subtitle">
                    <span>Enter your fuel usage in the input field</span>
                  </div>
                </b-skeleton-wrapper>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BCard,
  BCardTitle,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BFormDatepicker,
  BPagination,
  BProgress
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BCard,
    BCardTitle,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    vSelect,
    BFormDatepicker,
    BPagination,
    BProgress,
    flatPickr,
    VueApexCharts
  },

  directives: {
    Ripple
  },

  data() {
    return {
      data: [],
      token: '',
      deviceList: [],
      action: '',
      actor: '',

      loading: false,
      loadingTime: 0,
      maxLoadingTime: 3,

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      total_mileage: '',
      total_moving_time: '',
      total_parking_time: '',
      total_stop_time: '',
      total_speed_max: '',
      total_used_fuel: '',

      filter: {
        device: '',
        start_time: null,
        end_time: null,
        fuel: '',
        today: '',
        dateOption: { value: '', label: '-- Select Filter --' }
      },

      filtered: {
        device: '',
        start_time: null,
        end_time: null,
        fuel: '',
        today: '',
        dateOption: { value: '', label: '-- Select Filter --' }
      },

      dateList: [
        { value: '', label: '-- Select Filter --' },
        { value: 'today', label: 'Today' },
        { value: 'yesterday', label: 'Yesterday' },
        { value: 'define', label: 'Select Date' }
      ],

      today: '',
      yesterday: '',
      twoDaysAgo: '',
      maxDate: '',
      disableDate: true,

      filename: 'Journey Report',
      autoWidth: true,
      bookType: 'xlsx',

      chartOptions: {
        chart: {
          // height: 350,
          type: 'area',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            dataLabels: {
              position: 'top' // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        grid: {
          show: false
        },
        colors: ['#1DA1F2'],
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          show: false,
          type: 'datetime',
          categories: [
            '2018-09-19T00:00:00.000Z',
            '2018-09-19T01:30:00.000Z',
            '2018-09-19T02:30:00.000Z',
            '2018-09-19T03:30:00.000Z',
            '2018-09-19T04:30:00.000Z',
            '2018-09-19T05:30:00.000Z',
            '2018-09-19T06:30:00.000Z'
          ],
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        yaxis: {
          show: false,
          type: 'datetime',
          categories: [
            '2018-09-19T00:00:00.000Z',
            '2018-09-19T01:30:00.000Z',
            '2018-09-19T02:30:00.000Z',
            '2018-09-19T03:30:00.000Z',
            '2018-09-19T04:30:00.000Z',
            '2018-09-19T05:30:00.000Z',
            '2018-09-19T06:30:00.000Z'
          ],
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          }
        }
      },

      chartOptionsSpeedMax: {
        chart: {
          // height: 350,
          type: 'area',
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        grid: {
          show: false
        },
        colors: ['#DB4437'],
        stroke: {
          curve: 'straight'
        },
        xaxis: {
          show: false,
          type: 'datetime',
          categories: [
            '2018-09-19T00:00:00.000Z',
            '2018-09-19T01:30:00.000Z',
            '2018-09-19T02:30:00.000Z',
            '2018-09-19T03:30:00.000Z',
            '2018-09-19T04:30:00.000Z',
            '2018-09-19T05:30:00.000Z',
            '2018-09-19T06:30:00.000Z'
          ],
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        yaxis: {
          show: false,
          type: 'datetime',
          categories: [
            '2018-09-19T00:00:00.000Z',
            '2018-09-19T01:30:00.000Z',
            '2018-09-19T02:30:00.000Z',
            '2018-09-19T03:30:00.000Z',
            '2018-09-19T04:30:00.000Z',
            '2018-09-19T05:30:00.000Z',
            '2018-09-19T06:30:00.000Z'
          ],
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          }
        }
      },

      series: [
        {
          name: 'series',
          data: [31, 40, 28, 51, 42, 109, 100]
        }
      ],

      seriesMovingTime: [
        {
          name: 'series',
          data: [60, 30, 48, 21, 32, 99, 100]
        }
      ],

      seriesSpeedMax: [
        {
          name: 'series',
          data: [50, 39, 80, 51, 120, 80, 100]
        }
      ]
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },

    dateOption() {
      return this.filter.dateOption ? this.filter.dateOption.value : ''
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    dateOption() {
      let today = new Date()
      let yesterday = new Date(today)

      yesterday.setDate(yesterday.getDate() - 1)
      today = this.formatDate(today.toDateString())
      yesterday = this.formatDate(yesterday.toDateString())

      this.disableDate = true
      if (this.dateOption == 'today') {
        this.filter.start_time = this.today + ' 00:00'
        this.filter.end_time = this.today + ' 23:59'
        this.maxDate = this.today + ' 23:59'
      } else if (this.dateOption == 'yesterday') {
        this.filter.start_time = this.yesterday + ' 00:00'
        this.filter.end_time = this.yesterday + ' 23:59'
        this.maxDate = this.yesterday + ' 23:59'
      } else {
        this.filter.start_time = ''
        this.filter.end_time = ''
        this.maxDate = this.today + ' 23:59'
        // this.maxDate = this.twoDaysAgo + ' 23:59'
        this.disableDate = false
      }
    }

    // Test Loading
    // loading(newValue, oldValue) {
    //   if (newValue !== oldValue) {
    //     this.clearLoadingTimeInterval()

    //     if (newValue) {
    //       this.$_loadingTimeInterval = setInterval(() => {
    //         this.loadingTime++
    //       }, 1000)
    //     }
    //   }
    // },

    // loadingTime(newValue, oldValue) {
    //   if (newValue !== oldValue) {
    //     if (newValue === this.maxLoadingTime) {
    //       this.loading = false
    //     }
    //   }
    // }
  },

  created() {
    // this.$_loadingTimeInterval = null

    let today = new Date()
    let yesterday = new Date(today)
    let twoDaysAgo = new Date(today)

    yesterday.setDate(yesterday.getDate() - 1)
    twoDaysAgo.setDate(twoDaysAgo.getDate() - 2)

    this.today = this.formatDate(today.toDateString())
    this.yesterday = this.formatDate(yesterday.toDateString())
    this.twoDaysAgo = this.formatDate(twoDaysAgo.toDateString())

    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.searchDevice('')
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  // mounted() {
  //   this.startLoading()
  // },

  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.per_page + (index + 1)
    },

    updatePerPage(n) {
      this.per_page = n
    },

    // clearLoadingTimeInterval() {
    //   clearInterval(this.$_loadingTimeInterval)
    //   this.$_loadingTimeInterval = null
    // },
    // startLoading() {
    //   this.loading = true
    //   this.loadingTime = 0
    // },

    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('-')
    },

    searchDevice(keyword) {
      if (this.actor.privilege >= 4) {
        this.getDataDevice(keyword)
      } else {
        if (keyword.length >= 3) {
          this.getDataDevice(keyword)
        } else {
          this.deviceList = []
        }
      }
    },

    getDataDevice(keyword) {
      this.$http
        .get(
          `${this.$api.endpoint}/tracking/search?keyword=${keyword}&type=vehicle`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.deviceList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    initTable() {
      // console.log('yudha ganteng')

      this.data = []
      this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/report/journey_report`, {
          params: {
            page: this.page,
            per_page: this.per_page,
            device: this.filter.device ? this.filter.device.value : '',
            start: `${this.filter.start_time}:00`,
            end: `${this.filter.end_time}:00`,
            fuel: this.filter.fuel
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.loading = false
          this.$vs.loading.close(`#btn-cari > .con-vs-loading`)

          this.row_total = res.data.message.total
          this.data = res.data.message.data
          this.total_hours = 0

          this.total_mileage = res.data.message.total_mileage
          this.total_moving_time = res.data.message.total_moving_time
          this.total_parking_time = res.data.message.total_parking_time
          this.total_stop_time = res.data.message.total_stop_time
          this.total_speed_max = res.data.message.total_speed_max
          this.total_used_fuel = res.data.message.total_used_fuel

          this.getAddress()
          // console.log(this.data)
        })
        .catch((error) => {
          this.loading = false
          this.$vs.loading.close(`#btn-cari > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    search() {
      this.loading = true
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#btn-cari',
        scale: 0.45
      })

      this.filtered.device = this.filter.device
      this.filtered.start_time = this.filter.start_time
      this.filtered.end_time = this.filter.end_time
      this.filtered.fuel = this.filter.fuel

      this.page = 1
      this.initTable()
    },

    // async getAddress(data) {
    //   let temp = await data.map((item, index) => {
    //     setTimeout(() => {
    //       if (item.vehicle_status === 'Parking') {
    //         this.$http
    //           .get(`${this.$api.base_url}/api/address`, {
    //             params: {
    //               latitude: item.lat,
    //               longitude: item.lon
    //             }
    //           })
    //           .then((res) => {
    //             this.data[index].address = res.data.message
    //           })
    //       } else {
    //         this.$http
    //           .get(`${this.$api.base_url}/api/address`, {
    //             params: {
    //               latitude: item.lat,
    //               longitude: item.lon
    //             }
    //           })
    //           .then((res) => {
    //             this.data[index].start_address = res.data.message
    //           })

    //         this.$http
    //           .get(`${this.$api.base_url}/api/address`, {
    //             params: {
    //               latitude: item.lat,
    //               longitude: item.lon
    //             }
    //           })
    //           .then((res) => {
    //             this.data[index].end_address = res.data.message
    //           })
    //       }
    //     })
    //   })

    //   if (temp) {
    //     return data
    //   }
    // },

    getAddress() {
      this.data.map((item, index) => {
        setTimeout(() => {
          if (item.vehicle_status === 'Parking') {
            this.$http
              .get(`${this.$api.base_url}/api/address`, {
                params: {
                  latitude: item.lat,
                  longitude: item.lon
                }
              })
              .then((res) => {
                this.data[index].address = res.data.message
              })
          }
          if (item.vehicle_status === 'Moving') {
            this.$http
              .get(`${this.$api.base_url}/api/address`, {
                params: {
                  latitude: item.start_lat,
                  longitude: item.start_lon
                }
              })
              .then((res) => {
                this.data[index].start_address = res.data.message
              })

            this.$http
              .get(`${this.$api.base_url}/api/address`, {
                params: {
                  latitude: item.end_lat,
                  longitude: item.end_lon
                }
              })
              .then((res) => {
                this.data[index].end_address = res.data.message
              })
          }
          if (item.vehicle_status === 'Stop') {
            this.$http
              .get(`${this.$api.base_url}/api/address`, {
                params: {
                  latitude: item.lat,
                  longitude: item.lon
                }
              })
              .then((res) => {
                this.data[index].address = res.data.message
              })
          }
        }) // index * 300
      })
    },

    getAddress2() {
      this.data.map((item, index) => {
        setTimeout(() => {
          this.$http
            .get(`${this.$api.base_url}/api/address`, {
              params: {
                latitude: item.detail_journey.lat,
                longitude: item.detail_journey.lon
              }
            })
            .then((res) => {
              this.data[index].address = res.data.message
            })
        }, index * 300)
      })
    },

    toMapJourney(item) {
      // const toMapJourney = this.$router.resolve({
      //   path: '/map-journey/testing'
      // })
      // console.log(toMapJourney)
      localStorage.setItem('journeyData', JSON.stringify(item))
      localStorage.setItem(
        'journeyDataDetail',
        JSON.stringify(item.detail_journey)
      )

      // console.log(JSON.parse(localStorage.getItem('journeyData')))
      let route = this.$router.resolve({ path: '/map-summary' })
      window.open(route.href, '_blank')
      //   window.open(window.location.origin + '/map-journey', '_blank')
      this.getAddress2()
      // window.open(url, '_blank', 'noreferrer')
    },

    handleDownload() {
      // this.loading = true
      // this.$vs.loading({
      //   background: 'success',
      //   color: '#fff',
      //   container: '#btn-export',
      //   scale: 0.45
      // })

      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          'STATUS',
          'START DATE',
          'END DATE',
          'LOCATION',
          'START LOCATION',
          'END LOCATION',
          'DURATION',
          'MILEAGE',
          'AVERAGE SPEED'
        ]
        const filterVal = [
          'vehicle_status',
          'start',
          'end',
          'address',
          'start_address',
          'end_address',
          'duration_time',
          'drive_mileage',
          'average_speed'
        ]

        const list = this.data
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.$vs.loading.close(`#btn-export > .con-vs-loading`)
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    }
  }
}
</script>

<style>
/* Extra small devices (phones, 576px and down) */
@media (max-width: 576px) {
  .entries-export {
    display: none !important;
  }

  .statistik {
    margin-top: 20px;
  }
}

/* Small devices (portrait tablets and large phones, 576px and up) */
@media (min-width: 576px) and (max-width: 768px) {
  .entries-export {
    display: none !important;
  }

  .statistik {
    margin-top: 20px;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 992px) {
  .statistik {
    margin-top: 20px;
  }
}
</style>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

.parent {
  font-family: 'Poppins';
}

.bc li.active {
  font-weight: 600;
  color: #1da1f2;
}

.date-input-card,
.list-journey-card,
.statistik-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
}

// Date Input CSS

.date-input .date-picker {
  background-color: white;
  cursor: pointer;
  min-height: 45px;
}

.date-input #btn-cari {
  background-color: #28c76f;
  border: none;
  border-radius: 6px;
  font-weight: 500;
}

.date-input #btn-cari:hover {
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
}

// List Journery CSS

.list-journey h4 {
  font-weight: 600;
}

.list-journey #btn-export {
  background-color: #f8f7fa;
  color: #1da1f2;
  border: 1px solid #1da1f2;
  border-radius: 4px;
  font-weight: 500;

  &::before {
    content: url('~@/assets/images/tabler-icon/edited/report-medical-blue.svg');
    margin-top: 6px;
    margin-right: 7px;
  }
}

.list-journey #btn-export:hover {
  background-color: #1da1f2;
  color: #f8f7fa;

  &::before {
    content: url('~@/assets/images/tabler-icon/edited/report-medical-white.svg');
    margin-top: 6px;
    margin-right: 7px;
  }
}

.list-journey .table-container tbody {
  color: #4b465c;
}

.list-journey .lj-head {
  background-color: #1da1f2;
  color: #fff;
  text-align: center;
  padding: 20px 18px;
  vertical-align: middle;
}

.list-journey td {
  vertical-align: middle;
  font-weight: 600;
  font-size: 15px;
}

.list-journey .tag {
  font-weight: 600;
  font-size: 13px;
}

.list-journey .map-wrapper {
  background-image: url(../.././assets/images/file-icons/map-bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 4px;
  padding: 16px;
  color: #fff;
  font-style: italic;
  font-weight: 600;
}

.list-journey .map-wrapper a {
  color: #fff;
  font-style: italic;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

// Timeline CSS Component
.timeline ul,
.timeline li {
  list-style: none;
  padding: 0;
}

.timeline .timeline-wrapper {
  padding: 10px;
}

.timeline .timeline-sessions {
  position: relative;
}

.timeline .session-title {
  font-weight: 400;
  font-size: 0.929rem;
}

.timeline .session-subtitle {
  font-weight: 600;
  font-size: 1.071rem;
}

.timeline .session-time {
  font-weight: 400;
  font-size: 0.929rem;
}

.timeline li.session-1 {
  padding-bottom: 1.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    content: '';
    width: 15px;
    height: 15px;
    background: #1da1f2;
    box-shadow: 0px 0px 0px 4px rgba(0, 209, 232, 0.2);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}

.timeline li.session-2 {
  padding-bottom: 1.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    content: '';
    width: 15px;
    height: 15px;
    background: #db4437;
    box-shadow: 0px 0px 0px 4px rgba(75, 70, 92, 0.1);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}

.timeline li.session-3 {
  padding-bottom: 1.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    content: '';
    width: 15px;
    height: 15px;
    background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.1),
        rgba(255, 255, 255, 0.1)
      ),
      #4b465c;
    box-shadow: 0px 0px 0px 4px rgba(168, 170, 174, 0.3);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}

.timeline li.session-4 {
  padding-bottom: 1.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    // content: '';
    width: 15px;
    height: 15px;
    background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 0.5)
      ),
      #4b465c;
    box-shadow: 0px 0px 0px 4px rgba(75, 70, 92, 0.1);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}

.table_empty {
  text-align: center;
  font-size: 20px;
  padding: 10px;
  // border-left: 1px solid #ccc;
  // border-bottom: 1px solid #ccc;
  // width: 100%;
}

// Statistik CSS

.statistik {
  // position: -webkit-sticky;
  // position: sticky;
  // top: 150px;
  // overflow-y: auto;
  height: 100%;
}

.statistik-card {
  height: 100%;
  // display: flex;
  // align-items: center;
  // justify-content: center;
}

.statistik-title {
  font-weight: 600;
  font-size: 0.929rem;
}

.statistik-value {
  font-weight: 400;
  font-size: 0.929rem;
}

.statistik-subtitle {
  font-weight: 400;
  font-size: 0.814rem;
}

.statistik-card .gas-wrapper {
  background: rgba(255, 159, 67, 0.08);
  border-radius: 30px;
}
</style>
